import logger from '@/utils/logger'

import { ROLES_TO_AUTH_SCOPES } from '@/client/services/userRole/constants'
import type { UserAuthScope } from '@/client/services/userRole/types'
import type { AuthScope as WorldsAuthScope } from '@/client/services/worlds'

import getUserRoles from './getUserRoles'
import type { UserLike } from './types'

export default function getUserAuthScopes(user: UserLike): (UserAuthScope | WorldsAuthScope)[] {
  const roles = getUserRoles(user)
  const authScopes = new Set<UserAuthScope | WorldsAuthScope>()

  roles.forEach(role => {
    if (role in ROLES_TO_AUTH_SCOPES) {
      ROLES_TO_AUTH_SCOPES[role].forEach(authScope => {
        authScopes.add(authScope)
      })
    } else {
      logger.error(`Role#${role} is not recognized for User#${user.id}`)
    }
  })

  return Array.from(authScopes)
}
